import {Component, OnInit, ViewChild}             from '@angular/core';
import {ModalController, NavController}           from '@ionic/angular';
import {SessionService}                           from '../services/session.service';
import {Roles}                                    from '../enums/enums';
import {EditUserPage}                             from '../edit-user/edit-user.page';
import {EditContractPage}                         from '../edit-contract/edit-contract.page';
import {EditBonusPage}                            from '../edit-bonus/edit-bonus.page';
import {ActivatedRoute, Router}                   from '@angular/router';
import {DataStore}                                from '@aws-amplify/datastore';
import {Bonus, Contract, Team, User}              from '../../models';
import {S3LinkPipe}                               from '../pipes/s3-link.pipe';
import {APIService, GetUserQuery, PermissionType} from 'src/app/API.service';
import {ModalService}                             from "../services/modal.service";


enum UserFiles {
    FcartaIdentita = 'Carta Di Identità',
    FcartaIdentitaAutenticata = 'Carta Di Identità Autenticata',
    FdeclarationIndividual = 'Declaration Individual',
    Fextra1 = 'Extra 1',
    Fextra2 = 'Extra 2',
    FprofessionalReference = 'Professional Reference',
    FprovaResidednza = 'Prova Di residenza',
    FprovaResidenzaAutenticata = 'Prova Di Residenza Autenticata',
}

@Component({
    selector: 'app-profile',
    templateUrl: './profile.page.html',
    styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
    userId;
    // @ViewChild('filePickerComponent') filePickerComponent: FilePickerComponent;

    currentUser: GetUserQuery;
    profile = 'personal';
    currentPanel = 'elenco';
    clientFullName = '';
    assignedToFullName = '';
    addedByFullName = '';
    contractsList: any[];
    bonusList: any[];
    teamName = '';
    user = null;
    roles = Roles;
    pageTitle = 'My Profile';
    permessionTypes = PermissionType;

    constructor(
            private s3Link: S3LinkPipe,
            private route: ActivatedRoute,
            private navController: NavController,
            private modalController: ModalController,
            public router: Router,
            public sessionService: SessionService,
            private apiService: APIService,
            private modalService: ModalService,
    ) {

    }

    async ngOnInit() {

        await this.route.params.subscribe(async (params) => {
            this.userId = params['userId'];
            if (!this.userId) {
                const currentUser = this.sessionService.user;
                this.currentUser = currentUser;
                this.userId = currentUser.id;
            }
            this.currentUser = await this.apiService.GetUser(this.userId);
            

            await this.refreshContractsList();

            // Make sure we update the page title based on the user profile we're looking at
            /* if (this.currentUser?.id != currentUser?.id) {
                 this.pageTitle = `${this.currentUser.name} ${this.currentUser.lastname} Profile`;
             }*/
            await this.getAddedByUserName();


            // Load bonus if not client
            // this.bonusList = await (await DataStore.query(Bonus)).filter(b => b.userID == this.userId);
            this.bonusList = await DataStore.query(Bonus);
            

            // @todo let's see if a custom resolver in the backend let me fetch all related user details for a single user
            await this.renderModelNamesById();
        });


    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');

        let scrollerEl = document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].querySelector('.content-scroller');
        scrollerEl.addEventListener('scroll', function (e) {
            const lastKnownScrollPosition = e['target']['scrollTop'];

            const avatar = document.querySelectorAll('.main-header')[document.querySelectorAll('.main-header').length - 1].querySelector('.header-avatar');
            const content = document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].querySelector('.content');
            if (window.innerHeight - content.clientHeight < 0) {
                if (lastKnownScrollPosition >= 1) {
                    avatar.classList.add('resized');
                } else {
                    avatar.classList.remove('resized');
                }
            }
        });
    }

    async edit() {
        const modal = await this.modalController.create({
            component: EditUserPage,
            componentProps: {userId: this.currentUser.id},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshProfile();
        });
    }

    async toggleTRC20($event) {
        
        

        const original = await DataStore.query(User, this.currentUser.id);

        return DataStore.save(User.copyOf(original, updated => {
            updated.TRC20Active = $event.target.checked;
        }));
    }

    openContract(contractId: string) {
        this.router.navigate(['/contract', contractId]);
    }

    async editContract(contractId: string) {
        await this.openEditContractModal(contractId);
    }

    async addContract() {
        await this.openEditContractModal(null);
    }

    private async openEditContractModal(contractId: any) {
        this.modalService.contractEdit(contractId, undefined, this.currentUser).then(async d => {
            await this.refreshContractsList();
        });
    }

    async deleteContract(contractId: string) {
        if (confirm('Do you want to delete this Contract')) {
            await DataStore.delete(Contract, contractId);
            // let the animation finish its job
            setTimeout(async () => {
                await this.refreshContractsList();
            }, 1000);
        }
    }

    async refreshContractsList() {
        // defaults to Client's contract
        let queryFilter = c => c.clientId == this.userId;
        if (this.currentUser?.permessions != PermissionType.CLIENT) queryFilter = c => c.clientId == this.userId;
        if (this.currentUser == this.sessionService.getCurrentUser() && this.currentUser.permessions == PermissionType.ADMINISTRATOR) {
            this.contractsList = await (await DataStore.query(Contract));
        } else {
            this.contractsList = await (await DataStore.query(Contract)).filter(queryFilter);
            
        }
        //         this.contractsList = await (await DataStore.query(Contract));
        
        // this.ref.detectChanges();
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    openBonus(bonusId: string) {
        this.router.navigate(['/bonus', bonusId]);
    }

    editBonus(bonusId: string) {
        this.openEditBonustModal(bonusId);
    }

    private async openEditBonustModal(bonusId: any) {
        const modal = await this.modalController.create({
            component: EditBonusPage,
            componentProps: {bonusId: bonusId},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            // this.refreshContractsList();
        });
    }

    async deleteBonus(bonusId: string) {
        if (confirm('Do you want to delete this Bonus')) {
            await DataStore.delete(Bonus, bonusId);
            // let the animation finish its job
            setTimeout(() => {
                // this.refreshContractsList();
            }, 1000);
        }
    }


    back() {
        this.navController.back();
    }

    private async refreshProfile() {
        this.currentUser = await this.apiService.GetUser(this.currentUser.id);
        this.renderModelNamesById();
    }

    private async renderModelNamesById() {
        if (this.currentUser.teamID) {
            const team = await DataStore.query(Team, this.currentUser.teamID);
            this.teamName = team.name;
        }
        if (this.currentUser.assignedTo) {
            const assignedToUser = await DataStore.query(User, this.currentUser.assignedTo);
            this.assignedToFullName = `${assignedToUser.name} ${assignedToUser.lastname}`;
        }
        if (this.currentUser.addedBy) {
            await this.getAddedByUserName();
        }
    }

    async uploadFIle() {
        //  let m = this.filePickerComponent.uploadFile();
        //  
    }

    async updateFile(file: any) {
        
        let m = {
            id: this.currentUser.id,
            _version: this.currentUser._version,

        };
        m[file.name] = file.awsFile;
        this.currentUser = await this.apiService.UpdateUser(m);
        /* DataStore.save(User.copyOf(this.currentUser, u => {
             u[file.name] = file.awsFile;
         })).then(u => {
             
         });*/


    }

    getuserFiles(user: User | GetUserQuery,
    ) {
        let files = [];
        for (const f of Object.keys(UserFiles)) {
            if (user[f] != null) {
                files.push({
                    name: UserFiles[f],
                    file: user[f],
                });
            }
        }


        return files;
    }

    sendEmail() {

        let files = this.getuserFiles(this.currentUser);
        let att = [];
        let b = '<ul>';
        let c = '';

        for (let file of files) {

            const x = this.s3Link.transform(file.file);
            b = x ? b + '<li><a href="' + x + '" >' + file.name + '</a></li>' : '';
            c = '\n ' + x ? c + ' <a href="' + x + '" >' + file.name + '</a> ' : ' ';
            att.push(x);

        }
        b = b + '</ul>';


        //
        let email: any = {
            to: ['egyangel93@gmail.com'],
            // attachments: att,
            subject: 'Dati' + this.currentUser.name + ' ' + this.currentUser.lastname,
            body: c,
            isHtml: true,
            html: true,
        };

        

        //EmailComposer.open(email);


// Send a text message using default options
        // @ts-ignore
        //  this.emailComposer.open(email);
    }

    async shareDocuments() {
        await this.sendEmail();
    }

    async copy(string) {
        let aux = document.createElement('input');
        aux.setAttribute('value', string);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        
        document.body.removeChild(aux);
    }

    async getAddedByUserName() {
        /*   let name = await DataStore.query(User,
               this.currentUser.id);
           if (name)
               this.addedByFullName = name.lastname + ' ' + name.name;
           else
               this.addedByFullName = '';
   */
        
        if (this.currentUser.addedBy) {
            const addedByUser = await DataStore.query(User, this.currentUser.addedBy);
            this.addedByFullName = `${addedByUser?.name} ${addedByUser?.lastname}`;
        } else {
            this.addedByFullName = '';
        }
        
    }

    async deleteUser(user) {
        
        if (confirm('Eliminare utente')) {
            try {
                console.log(user._version)
                await this.apiService.DeleteUser({id:user.id,_version:user._version}).catch(e => {
                    console.log(e);
                } );
            }catch (e) {
                console.log(e);
            }

            // let the animation finish its job
            setTimeout(async () => {
                
               await this.back()
            }, 1000);

        }
    }
}
